import { render, staticRenderFns } from "./CompanyManage.vue?vue&type=template&id=69948d88&scoped=true"
import script from "./CompanyManage.vue?vue&type=script&lang=js"
export * from "./CompanyManage.vue?vue&type=script&lang=js"
import style0 from "./CompanyManage.vue?vue&type=style&index=0&id=69948d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69948d88",
  null
  
)

export default component.exports